import R from 'ramda';
import handleErrorUncurried from '../hocs/handleError';
import {
  component,
  buildPreloadedState,
  sanitizeAdditionalRoutes,
} from './helpers';
import Placeholder from '../components/Placeholder';

// NB: code from server directory won't be bundled on client due to webpack setup
// Ensures pattern followed when overriding component and buildPreloadedState keys
// TODO: [3] could this function benefit from type checking?
export const setupRouter = (
  {
    // Default pages
    defaultPages: {
      homeOverrides = {},
      aboutOverrides = {},
      categoryOverrides = {},
      subcategoryOverrides = {},
      productOverrides = {},
      notFoundOverrides = {},
    } = {},

    // Helper components, such as the error component
    helperComponents: {
      ErrorComponent = Placeholder,
    } = {},

    // Default pages to remove
    routesToRemove = [],

    // Additional pages (in addition to defaults)
    additionalRoutes = [],
  } = {},
) => {
  const NotFoundComponent = notFoundOverrides ? notFoundOverrides.component : Placeholder;
  const handleError = handleErrorUncurried(ErrorComponent, NotFoundComponent);

  const defaultRoutes = [
    {
      // NB: these keys can be overwritten
      path: '/:locale',
      exact: true,
      title: 'Home',
      ...homeOverrides,

      // NB: keys below the spread can't be overwritten due to order of execution
      id: 'home',
      component: component(homeOverrides.component, handleError),
      buildPreloadedState: buildPreloadedState(homeOverrides.buildPreloadedState, 'home'),
    },
    {
      path: '/:locale/about',
      exact: true,
      title: 'About',
      ...aboutOverrides,

      id: 'about',
      component: component(aboutOverrides.component, handleError),
      buildPreloadedState: buildPreloadedState(aboutOverrides.buildPreloadedState, 'about'),
    },
    {
      path: '/:locale/:category',
      exact: true,
      title: 'Category',
      ...categoryOverrides,

      id: 'category',
      component: component(categoryOverrides.component, handleError),
      buildPreloadedState: buildPreloadedState(categoryOverrides.buildPreloadedState, 'category'),
    },
    {
      path: '/:locale/:category/:subcategory',
      exact: true,
      title: 'Subcategory',
      ...subcategoryOverrides,

      id: 'subcategory',
      component: component(subcategoryOverrides.component, handleError),
      buildPreloadedState: buildPreloadedState(subcategoryOverrides.buildPreloadedState, 'subcategory'),
    },
    {
      path: '/:locale/:category/:subcategory/:product',
      exact: true,
      title: 'Product',
      ...productOverrides,

      id: 'product',
      component: component(productOverrides.component, handleError),
      buildPreloadedState: buildPreloadedState(productOverrides.buildPreloadedState, 'product'),
    },
    {
      title: 'Not Found',
      ...notFoundOverrides,

      id: 'notFound',
      component: component(notFoundOverrides.component, handleError),
      buildPreloadedState: buildPreloadedState(notFoundOverrides.buildPreloadedState, 'notFound'),
    },
  ];

  const usedDefaultRoutes = R.reduce((routesAcc, route) => (
    R.find(R.equals(route.id), routesToRemove) ? routesAcc : R.concat(routesAcc, [route])
  ), [], defaultRoutes);

  // TODO: [1] will react router config throw an error when multiple route with same id?
  const additionalRoutesSanitized = sanitizeAdditionalRoutes(additionalRoutes, ErrorComponent, NotFoundComponent);

  // NB: order matters - additional routes take precedence over default routes
  return R.concat(additionalRoutesSanitized, usedDefaultRoutes);
};
